import { useState } from 'react';
import { api, type Me } from '../api';
import { Link, useLocation } from '../router';

const MODE_LABELS = { disabled: 'Provisionnement désactivé', fake: 'Mode simulation', real: '' } as const;

export function Header({ me }: { me: Me }) {
  const { pathname } = useLocation();
  const [busy, setBusy] = useState(false);

  async function logout() {
    setBusy(true);
    let target = '/logged-out';
    try {
      // Le serveur ferme la session WHCC puis renvoie l'URL qui termine la session SSO : sans elle, Keycloak reconnecterait aussitôt.
      const { logoutUrl } = await api.logout();
      if (logoutUrl) target = logoutUrl;
    } catch {
      // en cas d'échec, la page de déconnexion propose de se reconnecter
    }
    window.location.assign(target);
  }

  return (
    <header className="app-header">
      <div className="header-inner">
        <Link href="/" className="brand" aria-label="WHCC, accueil">
          <span className="brand-mark" aria-hidden="true">
            W
          </span>
          <span className="brand-name">WHCC</span>
        </Link>
        <nav className="main-nav" aria-label="Navigation principale">
          <Link href="/" aria-current={pathname === '/' ? 'page' : undefined}>
            Mes instances
          </Link>
          {me.isAdmin && (
            <Link href="/admin" aria-current={pathname.startsWith('/admin') ? 'page' : undefined}>
              Administration
            </Link>
          )}
        </nav>
        <div className="header-user">
          {me.provisioningMode !== 'real' && (
            <span className={`badge ${me.provisioningMode === 'disabled' ? 'badge-red' : 'badge-orange'}`}>
              {MODE_LABELS[me.provisioningMode]}
            </span>
          )}
          <span className="user-name" title={me.user.email}>
            {me.user.displayName || me.user.username}
          </span>
          <button type="button" className="btn btn-small" onClick={logout} disabled={busy}>
            Déconnexion
          </button>
        </div>
      </div>
    </header>
  );
}
